/**
 * Модуль видео для лендингов (hero и video_reviews).
 */

function pauseLandingVideo(block) {
    const iframe = block.querySelector('[data-video-frame] iframe');
    if (!iframe || !iframe.contentWindow) {
        return;
    }

    try {
        iframe.contentWindow.postMessage(
            JSON.stringify({
                type: 'player:pause',
                data: {},
            }),
            '*',
        );
    } catch (e) {
        // Молча: если postMessage недоступен, плеер просто продолжит играть
    }
}

function buildAutoplayUrl(embedUrl) {
    const separator = embedUrl.includes('?') ? '&' : '?';

    return embedUrl + separator + 'autoplay=1';
}

export function initLandingVideo() {
    const blocks = document.querySelectorAll('[data-landing-video][data-video-embed-url]');
    if (!blocks.length) {
        return;
    }

    blocks.forEach((block) => {
        if (block.dataset.videoReady === '1') {
            return;
        }

        const embedUrl = block.getAttribute('data-video-embed-url');
        const thumbnail = block.querySelector('[data-video-thumbnail]');
        const actions = block.querySelector('[data-video-actions]');
        const frame = block.querySelector('[data-video-frame]');

        if (!embedUrl || !thumbnail || !frame) {
            return;
        }

        block.dataset.videoReady = '1';

        let iframeEl = null;

        function onPlay() {
            if (!iframeEl || !iframeEl.contentWindow) {
                return;
            }

            // Как в Vue: после player:ready просим старт и выставляем громкость
            try {
                iframeEl.contentWindow.postMessage(
                    JSON.stringify({
                        type: 'player:play',
                        data: {},
                    }),
                    '*',
                );
                iframeEl.contentWindow.postMessage(
                    JSON.stringify({
                        type: 'player:setVolume',
                        data: {volume: 0.9},
                    }),
                    '*',
                );
            } catch (e) {
                // Молча: если postMessage недоступен, просто не стартуем через протокол
            }
        }

        function onMessage(event) {
            try {
                const message = JSON.parse(event.data);
                if (message.type === 'player:ready' && block.dataset.videoShown === '1') {
                    onPlay();
                }
            } catch (e) {
                // Игнор: не JSON-сообщения
            }
        }

        window.addEventListener('message', onMessage);

        function showVideo() {
            if (block.dataset.videoShown === '1') {
                return;
            }

            document.querySelectorAll('[data-landing-video][data-video-shown="1"]').forEach((other) => {
                if (other !== block) {
                    pauseLandingVideo(other);
                }
            });

            block.dataset.videoShown = '1';

            // Скрываем превью визуально, но сохраняем его высоту,
            // чтобы видео не "уехало" вниз.
            thumbnail.style.visibility = 'hidden';
            thumbnail.style.pointerEvents = 'none';
            if (actions) {
                actions.hidden = true;
            }
            frame.hidden = false;

            if (frame.querySelector('iframe')) {
                return;
            }

            // Сначала показываем контейнер, затем вставляем iframe.
            // Это уменьшает шанс, что autoplay начнётся "до появления" блока.
            window.requestAnimationFrame(function () {
                if (frame.querySelector('iframe')) {
                    return;
                }

                const iframe = document.createElement('iframe');
                iframe.src = buildAutoplayUrl(embedUrl);
                iframe.frameBorder = '0';
                iframe.allow = embedUrl.indexOf('youtube.com') !== -1
                    ? 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                    : 'clipboard-write; autoplay';
                iframe.allowFullscreen = true;
                iframe.loading = 'lazy';
                iframeEl = iframe;
                frame.appendChild(iframe);
            });
        }

        thumbnail.addEventListener('click', function () {
            showVideo();
        });

        thumbnail.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                showVideo();
            }
        });

        const playButton = block.querySelector('[data-video-play-button]');
        if (playButton) {
            playButton.addEventListener('click', function () {
                showVideo();
            });
        }
    });
}
